// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__Sr_OY","addWidgetButton":"Header_addWidgetButton__2Dff0","dashboardTabs":"Header_dashboardTabs__3DQgp","active":"Header_active__2YNn4"};